var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('i',{staticClass:"tablehelper-boolean fal",class:[_setup.iconConfig.icon, _setup.iconConfig.class]})])
}
var staticRenderFns = []

export { render, staticRenderFns }